module.exports = __webpack_public_path__ + "static/block&tackle-c3e1460503a07757d9a82a011865a3f9.png";